// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth"; // Import getAuth
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyADAcVR1o0XupUzhbeFkku1YDmEbMSOlQk",
  authDomain: "ikeacallsense.firebaseapp.com",
  projectId: "ikeacallsense",
  storageBucket: "ikeacallsense.firebasestorage.app",
  messagingSenderId: "766020126685",
  appId: "1:766020126685:web:3df597f6ecba28ac57d834",
  measurementId: "G-27EQ9SGSKG"
};

// Initialize Firebase and conditionally initialize Analytics
const app = initializeApp(firebaseConfig);

let analytics;
if (typeof window !== 'undefined') {
  // Dynamically import getAnalytics to ensure it's only called in the browser
  import('firebase/analytics')
    .then(({ getAnalytics }) => {
      analytics = getAnalytics(app);
    })
    .catch((error) => console.error("Failed to load Firebase Analytics", error));
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export { app };